import React, { useEffect, useState } from 'react';
import './BookingTable.css';

import Edit from '../../Assets/Icons/Edit.svg'
import Delete from '../../Assets/Icons/Delete.svg'
import { supabase } from '../../supabase';

const BookingsTable = () => {

    const [bookings, setBookings] = useState([]);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [editStatus, setEditStatus] = useState('');
    const [editDate, setEditDate] = useState('');
    const [editTime, setEditTime] = useState('');

    const getBookings = async () => {
            // We select the columns we need from bookings, and cross-reference the users table
            const res = await supabase
                .from('bookings')
                .select(`
                    id,
                    status,
                    booking_date,
                    booking_time,
                    users (
                        first_name,
                        last_name,
                        email
                    )
                `);
            
            if (res.data) {
                setBookings(res.data);
            }
        };

    useEffect(() => {
        getBookings();
    }, []);

    const handleDeleteBooking = async (id) => {
        if (window.confirm("Are you sure you want to cancel and remove this booking?")) {
            const { error } = await supabase
                .from('bookings')
                .delete()
                .eq('id', id);

            if (error) {
                console.error("Error deleting booking:", error);
                alert("Failed to delete booking.");
            } else {
                // Instantly refresh the UI table
                getBookings();
            }
        }
    };

    const handleOpenEdit = (booking) => {
        setSelectedBooking(booking);
        setEditStatus(booking.status);
        setEditDate(booking.booking_date);
        setEditTime(booking.booking_time);
        setIsEditModalOpen(true);
    };

    const handleUpdateBooking = async (e) => {
        e.preventDefault();
        
        const { error } = await supabase
            .from('bookings')
            .update({
                status: editStatus,
                booking_date: editDate,
                booking_time: editTime
            })
            .eq('id', selectedBooking.id);

        if (error) {
            console.error("Error updating booking:", error);
            alert("Failed to update booking updates.");
        } else {
            setIsEditModalOpen(false);
            setSelectedBooking(null);
            await getBookings();
        }
    };


    // const dummyBookings = [
    //     { 
    //         id: 1, 
    //         created_at: '2024-11-12T09:30:00', 
    //         status: 'CONFIRMED', 
    //         users: { first_name: 'Mostafa', last_name: 'Ahmed', email: 'm.ahmed@example.com' } 
    //     },
    //     { 
    //         id: 2, 
    //         created_at: '2024-11-12T11:15:00', 
    //         status: 'PENDING', 
    //         users: { first_name: 'Sarah', last_name: 'Kamel', email: 'sarah.k@tesla-mena.com' } 
    //     },
    //     { 
    //         id: 3, 
    //         created_at: '2024-11-13T14:00:00', 
    //         status: 'CONFIRMED', 
    //         users: { first_name: 'Omar', last_name: 'Mansour', email: 'omansour@energy-corp.eg' } 
    //     },
    //     { 
    //         id: 4, 
    //         created_at: '2024-11-14T10:45:00', 
    //         status: 'CANCELLED', 
    //         users: { first_name: 'Heba', last_name: 'Nassar', email: 'h.nassar@consultant.eg' } 
    //     },
    //     { 
    //         id: 5, 
    //         created_at: '2024-11-14T16:30:00', 
    //         status: 'PENDING', 
    //         users: { first_name: 'Ziad', last_name: 'Ali', email: 'ziad.ali@startup.io' } 
    //     },
    //     { 
    //         id: 6, 
    //         created_at: '2024-11-15T08:00:00', 
    //         status: 'CONFIRMED', 
    //         users: { first_name: 'Laila', last_name: 'Hossam', email: 'laila.h@design-studio.com' } 
    //     },
    //     { 
    //         id: 7, 
    //         created_at: '2024-11-16T12:20:00', 
    //         status: 'CANCELLED', 
    //         users: { first_name: 'Youssef', last_name: 'Zaki', email: 'y.zaki@freelance.com' } 
    //     }
    // ];

    return (
        <div className="TableContainer">
            <table className="CustomTable">
                <thead>
                    <tr>
                        <th>ATTENDEE NAME</th>
                        <th>EMAIL ADDRESS</th>
                        <th>DATE / TIME</th>
                        <th>STATUS</th>
                        <th>ACTION</th>
                    </tr>
                </thead>
                <tbody>
                    {bookings.map((row) => (
                        <tr key={row.id}>
                            <td className="BoldText">
                                {row.users.first_name} {row.users.last_name}
                            </td>
                            <td className="SubText">{row.users.email}</td>
                            <td>
                                {new Date(row.booking_date).toLocaleDateString('en-US', { 
                                    month: 'short', day: 'numeric', year: 'numeric' 
                                })} • {row.booking_time}
                            </td>
                            <td>
                                <span className={`StatusBadge ${row.status.toLowerCase()}`}>
                                    {row.status}
                                </span>
                            </td>
                            <td className='ActionBtns'>
                                    <button className='EditBtn' onClick={() => handleOpenEdit(row)}>
                                        <img src={Edit} alt="" />
                                    </button>

                                    <button className='EditBtn' onClick={() => handleDeleteBooking(row.id)}>
                                        <img src={Delete} alt="" />
                                    </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {isEditModalOpen && (
                <div className="BookingModalOverlay">
                    <div className="BookingModalContent">
                        <h3>Update Reservation</h3>
                        <p className="ModalAttendeeSub">
                            Attendee: <strong>{selectedBooking?.users?.first_name} {selectedBooking?.users?.last_name}</strong>
                        </p>
                        
                        <form onSubmit={handleUpdateBooking}>
                            <div className="FormGroup">
                                <label>Date</label>
                                <input 
                                    type="date" 
                                    value={editDate} 
                                    onChange={(e) => setEditDate(e.target.value)} 
                                    required 
                                />
                            </div>

                            <div className="FormGroup">
                                <label>Time Slot</label>
                                <input 
                                    type="text" 
                                    value={editTime} 
                                    onChange={(e) => setEditTime(e.target.value)} 
                                    required 
                                />
                            </div>

                            <div className="FormGroup">
                                <label>Reservation Status</label>
                                <select 
                                    value={editStatus} 
                                    onChange={(e) => setEditStatus(e.target.value)}
                                >
                                    <option value="pending">Pending</option>
                                    <option value="confirmed">Confirmed</option>
                                    <option value="completed">Completed</option>
                                    <option value="cancelled">Cancelled</option>
                                </select>
                            </div>

                            <div className="ModalActions">
                                <button type="button" className="CancelBtn" onClick={() => setIsEditModalOpen(false)}>
                                    Cancel
                                </button>
                                <button type="submit" className="SaveBtn">
                                    Save Changes
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

        </div>
    );
};

export default BookingsTable;